import type { FC, Ref } from 'react';
import { memo, useState } from 'react';

import { WithTooltip, type IWithTooltipProps } from '@ui/elements/Tooltip'

export interface IWithEllipsisTooltipProps extends IWithTooltipProps {
  ref?: Ref<WithTooltip>
}

const isEllipsized = (node) => {
  return node.offsetWidth < node.scrollWidth
}

export const WithEllipsisTooltip: FC<IWithEllipsisTooltipProps> =
  memo(({ children, ...tooltipProps }) => {
    const [isOpen, setIsOpen] = useState(false)

    const onMouseOver = (e) => {
      if (isEllipsized(e.currentTarget)) {
        setIsOpen(true)
      }
    }

    const onMouseOut = () => {
      if (!isOpen) return
      setIsOpen(false)
    }

    return !children ? null : (
      <WithTooltip
        open={isOpen}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        onMouseOut={onMouseOut}
        onMouseOver={onMouseOver}
        {...tooltipProps}
      >
        {children}
      </WithTooltip>
    )
  })

WithEllipsisTooltip.defaultProps = {}
WithEllipsisTooltip.displayName = 'WithEllipsisTooltip'
